/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize RolesCreation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './rolesCreationView';

export const mapStateToPropsRoleCreation = mapStateToProps;
export const mapDispatchToPropsRoleCreation = mapDispatchToProps;

export default connect(
  mapStateToPropsRoleCreation,
  mapDispatchToPropsRoleCreation
)(View);
